export default "__VITE_ASSET__CiBH2RWd__"